import './assets/main.css'

import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import CButton from './components/atoms/CButton.vue'
import router from './core/router'

//guards
import './core/guards/auth_guard'

import '@mdi/font/css/materialdesignicons.css' // iconos mdi
import 'vuetify/styles'

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import CDatePicker from './components/atoms/CDatePicker.vue'
import CInput from './components/atoms/CInput.vue'
import CPassword from './components/atoms/CPassword.vue'
import CSelect from './components/atoms/CSelect.vue'
import CTime from './components/atoms/CTime.vue'
import CFile from './components/atoms/CFile.vue'
import CSlider from './components/atoms/CSlider.vue'
import CDialog from './components/atoms/CDialog.vue'
import CAutoComplete from './components/atoms/CAutoComplete.vue'
import CUploadDropbox from './components/molecules/CUploadDropbox.vue'

const vuetify = createVuetify({
  components: {
    components,
    VFileUpload,
  },
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#001F4A',
          secondary: '#FF7043',
          accent: '#26A69A',
          background: '#F5F5F5',
          surface: '#FFFFFF',
          error: '#D32F2F',
          info: '#1976D2',
          success: '#388E3C',
          warning: '#FFA000',
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#2196F3',
          secondary: '#FF4081',
          accent: '#9C27B0',
          background: '#121212',
          surface: '#1E1E1E',
          error: '#FF5252',
          info: '#448AFF',
          success: '#4CAF50',
          warning: '#FFEB3B',
        },
      },
    },
  },
})

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vuetify)

app.component('v-c-button', CButton)
app.component('v-c-input', CInput)
app.component('v-c-password', CPassword)
app.component('v-c-select', CSelect)
app.component('v-c-date-picker', CDatePicker)
app.component('v-c-time', CTime)
app.component('v-c-file', CFile)
app.component('v-c-slider', CSlider)
app.component('v-c-dialog', CDialog)
app.component('v-c-autocomplete', CAutoComplete)
app.component('v-c-dropbox', CUploadDropbox)
app.mount('#app')
